import Changelog from './Changelog';
import { useApp } from '../store';

/**
 * WHICH BUILD YOU ARE RUNNING, up by the wordmark.
 *
 * It used to live at the very foot of the sidebar (in AccountPanel), which meant
 * a long nav pushed it below the fold and finding your version was a scroll to
 * the bottom (Vinnie, 26 Sep). Here it is on screen the instant the app opens.
 *
 * THE NUMBER IS THE WHOLE CHIP, and the rest rides in the tooltip and the
 * changelog it opens — the commit, and whether this build is a candidate for a
 * release or unreleased work on top of one — so the chip stays a chip. Clicking
 * it answers "what changed?", which is the natural question a version invites.
 */
export default function VersionChip() {
  // Shared with the What's new callout so both open the one changelog surface.
  const showLog = useApp((s) => s.changelogOpen);
  const setShowLog = useApp((s) => s.setChangelogOpen);
  // A RELEASED build shows the version and NOTHING ELSE (Vinnie, 26 Sep): on live
  // the version IS the release, and the `+build` count is a development-line
  // detail a customer has no use for. A test build keeps the full `+count` and the
  // "for/on" suffix below, because that is what tells two builds of one release
  // apart (#256). On live __APP_VERSION__ is already clean; the strip guarantees it.
  const released = !__RELEASE_CANDIDATE__ && !__SINCE_LIVE__;
  const shownVersion = released ? __APP_VERSION__.split('+')[0] : __APP_VERSION__;
  return (
    <>
      <button
        className="version-chip"
        title={
          __RELEASE_CANDIDATE__
            ? `What's new — a candidate for live ${__RELEASE_CANDIDATE__} · ${__BUILD_COMMIT__}`
            : __SINCE_LIVE__
              ? `What's new — unreleased work on live ${__SINCE_LIVE__.split('+')[0]} · ${__BUILD_COMMIT__}`
              : `What's new — ${__BUILD_COMMIT__}`
        }
        onClick={() => setShowLog(true)}
        data-reveal="whats-new"
      >
        v{shownVersion}
        {/* On a test build, WHAT IT IS A CANDIDATE FOR stays visible on the
            version itself — not only the top banner — because a stale candidate
            is caught by seeing it (#256, and the 2.7.1+29 morning). Empty on live,
            where the number above IS the release. */}
        {__RELEASE_CANDIDATE__ && (
          <span className="version-candidate">for {__RELEASE_CANDIDATE__}</span>
        )}
        {!__RELEASE_CANDIDATE__ && __SINCE_LIVE__ && (
          <span className="version-candidate">on {__SINCE_LIVE__}</span>
        )}
      </button>
      {showLog && <Changelog onClose={() => setShowLog(false)} />}
    </>
  );
}
